<template>
  <el-form-item :class="[component.properties.sortType==='toTop'&& 'to-top',component.properties.sortType==='hidden'&& 'hidden','rc-upload-runtime', dragActive && 'rc-upload-drag-style', getClassByCopy,!isPicture && 'rc-upload-not-img-style']"
                ref="uploadForm"
                :prop="getProp"
                :rules="rules"
                @dragenter.native.prevent.stop="dragenterEvent"
                @dragleave.native.prevent.stop="dragleaveEvent"
                @drop.native.stop.prevent="dragUploadFile"
                :label-width="labelParameter.width">
    <div v-if="labelParameter.showSlot"
         :class="['control-label', labelParameter.className]"
         slot="label"
         :title="component.name">{{labelParameter.labelName}}</div>
    <span v-else slot="label" :title="component.name">{{ labelParameter.labelName }}</span>
    <el-tooltip class="component-explain-tooltip" v-if="component.properties.componentExplain" :content="component.properties.componentExplain" placement="bottom-start">
      <span class="fa fa-question-circle"></span>
    </el-tooltip>
    <el-upload
      ref="uploadControl"
      :class="['rc-upload-control']"
      name="files"
      action=""
      :headers="headers"
      :multiple="component.properties.multiple"
      :list-type="component.properties.listType"
      :before-upload="beforeUpload"
      :http-request="uploadFile"
      :on-preview="downFile"
      :show-file-list="false"
      :data="dataType"
      :auto-upload="!component.properties.multiple"
      :on-change="fileChange">
      <el-button :class="['upload-button', dragActive && 'rc-upload-button-drag']" type="text">{{dragActive ? (isPicture ? '释放即可添加图片':'释放即可添加附件'): (isPicture?'添加图片':'添加附件')}}</el-button>
    </el-upload>
    <div :class="[!isPicture && 'accessory',isPicture && 'img-accessory']"  v-show="fileLists.length > 0">
      <template v-if="fileLists.length > 1 && !isPicture">
        <el-dropdown v-if="fileLists.length" placement="bottom-start" :hide-on-click='false'>
        <span class="el-dropdown-link" v-show="!dragActive">
          <span class="multiple-accessory">{{fileLists[0] && fileLists[0].name}}</span> ( {{ getUploadSuccessFileLength }} )<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
          <el-dropdown-menu ref="uploadDropdownMenu"
                            class="rc-file-dropdown rc-file-dropdown-picture"
                            slot="dropdown"
                            v-if="fileLists.length > 1">
            <vue-draggable v-model="fileLists" @update="updateFileOrder">
              <transition-group>
                <el-dropdown-item v-for="item in fileLists" :key="item.url">
                  <a class="item" :title="item.name">{{ item.name }}</a>
                  <i v-if="$refs.uploadForm.$el.getAttribute('disabled') !== 'disabled'"
                     class="el-icon-circle-close"
                     @click.stop="delFile(item, fileLists)"></i>
                  <div v-if="item.loading" class="progress"><el-progress color="#53A6E8" :stroke-width="3" :show-text="false" :percentage="getPercentage(item)"></el-progress></div>
                  <div class="preivew-or-down picture-upload">
                    <div class="preivew" @click.stop="previewFile(item)">
                      <i class="el-icon-view"></i><span>预览</span>
                    </div>
                    <div class="external-link-preview" v-if="hasNewWindow(item)" @click.stop="externalLinkPreview(item)">
                      <i></i><span>新窗口预览</span>
                    </div>
                    <div class="down" @click.stop="downFile(item)">
                      <i class="el-icon-download"></i><span>下载</span>
                    </div>
                    <div class="pack-down-all" @click.stop="packDown">
                      <i></i><span>打包下载</span>
                    </div>
                  </div>
                </el-dropdown-item>
              </transition-group>
            </vue-draggable>
          </el-dropdown-menu>
        </el-dropdown>
      </template>
      <template v-else-if ="!isPicture">
        <div v-if="fileLists[0] && !dragActive" class="item item-one-file">
          <span class="file-name" :title="fileLists[0].name">{{ fileLists[0].name }}</span>
          <i v-if="$refs.uploadForm.$el.getAttribute('disabled') !== 'disabled'" class="el-icon-circle-close"
             @click.stop="delFile(fileLists[0], fileLists)"></i>
          <div v-if="fileLists[0].loading" class="progress"><el-progress color="#53A6E8" :stroke-width="3" :show-text="false" :percentage="getPercentage(fileLists[0])"></el-progress></div>
          <div class="preivew-or-down picture-upload">
            <div class="preivew" @click.stop="previewFile(fileLists[0])">
              <i class="el-icon-view"></i><span>预览</span>
            </div>
            <div class="external-link-preview" v-if="hasNewWindow(fileLists[0])" @click.stop="externalLinkPreview(fileLists[0])">
              <i></i><span>新窗口预览</span>
            </div>
            <div class="down" @click.stop="downFile(fileLists[0])">
              <i class="el-icon-download"></i><span>下载</span>
            </div>
          </div>
        </div>
      </template>
      <template>
        <div :class="'imgs-drag'+component.id" animation="500" handle='.moveImg' class="imgs-drag-wraper" v-show="isPicture && fileLists.length > 0">
            <ThumbnailPreview ref='thumbnailPreview' v-for="item in fileLists" :key='item.url' :imgData='item'
              :disabled="$refs.uploadForm.$el.getAttribute('disabled') === 'disabled'"
              @previewFile='previewFile'
              @externalLinkPreview='externalLinkPreview'
              @downFile='downFile'
              @changeImgName='changeImgName'
              @deleteImg='deleteImg'>
            </ThumbnailPreview>
        </div>
        <div class="pack-down-all img-pack-all" v-show="isPicture && fileLists.length > 1">
          <el-tooltip  effect="dark" content="打包下载" placement="bottom" popper-class='img-pre-tooltip'>
            <i @click.stop="packDown"></i>
          </el-tooltip>
        </div>
      </template>
    </div>
    <!-- 文件上传提示 -->
    <el-dialog v-if="dialogParams.visable"
               class="rc-upload-dialog"
               title="附件上传提示"
               :visible.sync="dialogParams.visable"
               :width="dialogParams.width"
               append-to-body center
               :close-on-click-modal="false"
               :top="dialogParams.type === 'hint' ? '28vh' : '20vh'"
               @close="cancel">
      <div v-if="dialogParams.type === 'hint'" class="hint" v-html="dialogParams.hint"></div>
      <div v-else class="file-select-list">
        <div class="title">
          <div class="left">文件名</div>
          <div class="right">大小</div>
        </div>
        <div class="file-content">
          <div :class="['item', item.checked && 'checked-item']" v-for="(item, i) in getFileList" :key="i">
            <div class="left file-name">
              <span :class="['name', item.size >= maxSize && 'name-hint']" :title="item.name">
                <el-checkbox :disabled="item.size >= maxSize" v-model="item.checked">{{item.name}}</el-checkbox>
              </span>
              <span v-if="item.size >= maxSize" style="color: red;">(超过{{component.properties.fileSize || 50}}M限制)</span>
            </div>
            <div class="right size">{{ getFileSize(item.size) }}</div>
          </div>
        </div>
        <!-- 这玩意不需要四舍五入 -->
        <div class="file-footer">已选择{{ Math.floor(getSelectSize * 100) / 100 }}M，可以上传（有{{ getNoUploadFile }}个不能上传）</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div v-if="dialogParams.type === 'hint'" class="hint-button">
          <el-button @click="cancel">确定</el-button>
        </div>
        <div v-else class="select-file">
          <el-button @click="save" type="primary">确定</el-button>
          <el-button @click="cancel">取消</el-button>
        </div>
      </span>
    </el-dialog>
    <!--图片预览-->
    <PicturePreview ref="picturePreview" @closePreview="closePreview" :coverPicList="coverPicList" v-if="swiperFlag" :src="previewFileSrc"></PicturePreview>
  </el-form-item>
</template>

<script>
import {componentMixin, inputMixin, ossMixin, uploadMixin} from './mixins'
import tokenStorage from '@/plugins/tokenStorage'
import PicturePreview from './picture-preview-swiper'
import ThumbnailPreview from './thumbnail-preview'
import VueDraggable from 'vuedraggable'
import JSZip from 'jszip'
import OSS from 'ali-oss'
import Sortable from 'sortablejs'
import basicAxios from 'axios'
export default {
  name: 'rc-upload',
  mixins: [componentMixin, inputMixin, ossMixin, uploadMixin],
  props: ['component', 'value', 'index', 'labelParameter'],
  inject: ['initState', 'initCount'],
  components: {
    PicturePreview,
    VueDraggable,
    ThumbnailPreview
  },
  data () {
    let maxSize = 50
    if (this.component.properties.fileSize) {
      maxSize = parseInt(this.component.properties.fileSize) <= 100 ? parseInt(this.component.properties.fileSize) : 100
    }
    maxSize = maxSize * 1024 * 1024
    let symbolKey = String(Symbol(new Date().valueOf()))
    return {
      isPicture: false,
      fileList: [],
      headers: {'Authorization': tokenStorage.getToken()},
      dataType: {type: 'USER'},
      uploading: false,
      fileLists: [],
      timers: [],
      timeOut: null,
      dialogParams: {
        visable: false,
        width: '398px',
        type: 'hint',
        hint: ''
      },
      maxSize: maxSize,
      selectFileList: {
        list: [],
        selected: []
      },
      isUpload: false,
      swiperFlag: false,
      coverPicList: [],
      previewFileSrc: '',
      symbolKey,
      sortFileLists: []
    }
  },
  watch: {
    'initState.state' (val) {
      if (val) {
        this.initFileList()
      }
    },
    'initCount.value' (val) {
      if (val > 0) {
        this.$set(this, 'fileList', [])
        this.$set(this, 'fileLists', [])
      }
    },
    'fileLists.length' (val) {
      if (val > 1) {
        // 预览的时候不要自动展开
        this.$nextTick(() => !this.swiperFlag && this.isUpload && this.$refs && this.$refs.uploadDropdownMenu && this.$refs.uploadDropdownMenu.dropdown && this.$refs.uploadDropdownMenu.dropdown.show())
      }
    },
    // 这个监听是为了数据绑定更改归档数据的时候能实时展示更新
    value (val) {
      if (val) {
        let fileArray = val.split('$.$')
        let newFileList = []
        let allowType = ['png', 'jpg', 'jpeg', 'gif']
        fileArray.forEach(m => {
          if (m) {
            let name = m.split(',/')[0]
            let type = name.substring(name.lastIndexOf('.') + 1)
            // 如果是关联的图片类型的控件, 过滤掉所有非图片文件
            if (this.component.properties.listType === 'picture') {
              if (allowType.some(n => n === type.toLocaleLowerCase())) {
                newFileList.push({name: name, url: m.slice(m.indexOf(',/') + 1)})
              }
            } else {
              newFileList.push({name: name, url: m.slice(m.indexOf(',/') + 1)})
            }
          }
        })
        this.fileLists = newFileList
      }
    }
  },
  created () {
    window.addEventListener('beforeunload', this.removeSymbolKey, false)
    window.addEventListener('load', this.removeSymbolKey, false)
    this.isPicture = (this.component.properties.listType === 'picture')
  },
  mounted () {
    // 上传控件允许拖入事件
    this.initDragEvent('uploadForm')
    this.rules.push({
      validator: (rule, value, callback) => {
        if (this.uploading) {
          callback(new Error('文件上传中，请稍候'))
        } else {
          callback()
        }
      }
    })
    let that = this
    let el = document.querySelectorAll('.imgs-drag' + this.component.id)[0]
    Sortable.create(el, {
      animation: 500,
      handle: '.moveImg',
      onUpdate: function (e) {
        if (e.newIndex !== e.oldIndex) {
          let pre = that.fileLists[e.oldIndex]
          that.fileLists[e.oldIndex] = that.fileLists[e.newIndex]
          that.fileLists[e.newIndex] = pre
          that.updateFileOrder()
        }
      }
    })
  },
  methods: {
    // 删除图片
    deleteImg (item) {
      this.delFile(item, this.fileLists)
    },
    // 修改图片名称，修改归档数据
    changeImgName () {
      let value = ''
      this.fileLists.forEach(f => {
        value += `$.$${f.name},${f.url}`
      })
      this.update(value)
    },
    async multipartUpload (files, config, key, checkpoint) {
      let client = new OSS(config)
      let file = files.file
      try {
        this.fileProgress(file)
        await client.multipartUpload('/' + key, files.file, {
          progress: (p, cpt) => {
            checkpoint = cpt
          },
          checkpoint: checkpoint
        })
        this.updateFile(this.getResult(key, file.name), file)
      } catch (e) {
        const _this = this
        if (e.name === 'SecurityTokenExpiredError') {
          _this.$axios.get('/shared-api/files/oss/sts').then(res => {
            const bucketEnvironment = sessionStorage.getItem('ossDownloadUrl').indexOf('ywdev') === -1 ? 'ywprod' : 'ywdev'
            let ossConfig = {
              region: 'oss-cn-hangzhou', // 根据那你的Bucket地点来填写
              accessKeyId: res.data.accessKeyId, // 自己账户的accessKeyId
              accessKeySecret: res.data.accessKeySecret, // 自己账户的accessKeySecret
              stsToken: res.data.securityToken,
              bucket: bucketEnvironment, // bucket名字
              secure: true
            }
            _this.multipartUpload(files, ossConfig, key, checkpoint)
          })
        } else if (e.name === 'ConnectionTimeoutError') {
          await _this.multipartUpload(files, config, key, checkpoint)
        } else {
          window.addEventListener('online', async function reLoad () {
            try {
              let file = files.file
              await client.multipartUpload('/' + key, files.file, {
                progress: (p, cpt) => {
                  checkpoint = cpt
                },
                checkpoint: checkpoint
              })
              _this.updateFile(_this.getResult(key, file.name), file)
              window.removeEventListener('online', reLoad)
            } catch (e) {
              const __this = _this
              if (e.name === 'SecurityTokenExpiredError') {
                window.removeEventListener('online', reLoad)
                __this.$axios.get('/shared-api/files/oss/sts').then(res => {
                  const bucketEnvironment = sessionStorage.getItem('ossDownloadUrl').indexOf('ywdev') === -1 ? 'ywprod' : 'ywdev'
                  let ossConfig = {
                    region: 'oss-cn-hangzhou', // 根据那你的Bucket地点来填写
                    accessKeyId: res.data.accessKeyId, // 自己账户的accessKeyId
                    accessKeySecret: res.data.accessKeySecret, // 自己账户的accessKeySecret
                    stsToken: res.data.securityToken,
                    bucket: bucketEnvironment, // bucket名字
                    secure: true
                  }
                  __this.multipartUpload(files, ossConfig, key, checkpoint)
                })
              } else if (e.name === 'ConnectionTimeoutError') {
                await _this.multipartUpload(files, config, key, checkpoint)
              }
            }
          })
        }
      }
    },
    async uploadFile (files) {
      let file = files.file
      let key = this.getOssKey('USER', file.name)
      if (files.file.size > 104857600) {
        this.$axios.get('/shared-api/files/oss/sts').then(res => {
          const bucketEnvironment = sessionStorage.getItem('ossDownloadUrl').indexOf('ywdev') === -1 ? 'ywprod' : 'ywdev'
          let ossConfig = {
            region: 'oss-cn-hangzhou', // 根据那你的Bucket地点来填写
            accessKeyId: res.data.accessKeyId, // 自己账户的accessKeyId
            accessKeySecret: res.data.accessKeySecret, // 自己账户的accessKeySecret
            stsToken: res.data.securityToken,
            bucket: bucketEnvironment, // bucket名字
            secure: true
          }
          this.multipartUpload(files, ossConfig, key, null)
        })
      } else {
        this.fileProgress(file)
        let url = sessionStorage.getItem('ossDownloadUrl')
        let formData = this.getUploadFormData(key, file)
        let fileItem = this.sortFileLists.find(f => f.file === file)
        this.$axios.post(url, formData, {
          headers: {'Content-Type': 'multipart/form-data'},
          cancelToken: new basicAxios.CancelToken(c => {
            if (fileItem) {
              fileItem.cancel = c
            }
          })
        }).then(res => {
          res.status === 200 ? this.updateFile(this.getResult(key, file.name), file) : this.uploadFailed('', file)
        })
      }
    },
    inited (viewer) {
      this.$viewer = viewer
    },
    initFileList () {
      this.fileLists = []
      if (this.value) {
        let list = this.value.split('$.$').filter(item => item.trim() !== '')
        list.forEach(n => {
          if (n && n !== 'undefined') {
            this.fileLists.push({name: n.split(',/')[0], url: '/' + n.split(',/')[1]})
          }
        })
      }
    },
    fileChange (file, fileList) {
      if (file && file.status === 'ready') {
        let self = this
        if (self.component.properties.multiple) {
          if (self.timeOut) {
            clearTimeout(self.timeOut)
          }
          this.timeOut = setTimeout(() => {
            let list = fileList.filter(f => f.size >= self.maxSize)
            if (list && list.length > 0) {
              if (fileList.filter(f => f && f.status === 'ready').length === 1) {
                let hint = `您选择的文件不能上传，原因如下:<br><span title="${file.name}" class="file-name">${file.name}</span><span style="color: red">(超过${this.component.properties.fileSize || 50}M限制)</span>`
                this.openDialog({visable: true, width: '398px', type: 'hint', hint})
              } else {
                this.selectFileList.list = fileList
                let fl = this.$_.cloneDeep(fileList)
                // 加上是否勾选标识
                fl.forEach(f => { f.checked = f.size < self.maxSize })
                this.selectFileList.selected = fl
                this.openDialog({visable: true, width: '430px', type: 'select'})
              }
            } else {
              self.$refs.uploadControl.submit()
              // submit 之后清空 文件列表
              self.$refs.uploadControl.clearFiles()
            }
          }, 10)
        }
      }
    },
    beforeUpload (file) {
      if (!this.isUpload) {
        this.isUpload = true
      }
      if (this.component.properties.multiple === false) {
        // 单文件上传，如果有文件正在上传，需要取消正在上传的文件
        let findFile = this.fileLists.find(f => f.loading)
        findFile && this.$refs.uploadControl.abort(findFile.file)
        this.fileLists = []
        if (file.size >= this.maxSize) {
          let hint = `您选择的文件不能上传，原因如下:<br><span title="${file.name}" class="file-name">${file.name}</span><span style="color: red">(超过${this.component.properties.fileSize || 50}M限制)</span>`
          this.openDialog({visable: true, width: '398px', type: 'hint', hint})
          return false
        }
      }
      let type = file.name.split('.').pop()
      if (this.component.properties.listType === 'picture') {
        // 图片选择控件
        let allowType = ['png', 'jpg', 'jpeg', 'gif']
        if (!allowType.some(n => n === type.toLocaleLowerCase())) {
          this.$message.warning('图片类型上传文件只能是图片格式')
          return false
        }
      } else if (this.component.properties.allowFileType && this.component.properties.allowFileType.length !== 0) {
        // 文件选择控件和表格内的文件选择 如果设置了上传文件的允许类型,则判断
        if (!this.component.properties.allowFileType.some(n => n === type.toLowerCase())) {
          this.$message.warning(`只能上传${this.component.properties.allowFileType.join()}格式的文件`)
          return false
        }
      }
      this.uploading = true
      this.fileLists.push({name: file.name, url: file.uid, loading: true, file, progress: 0})
      this.sortFileLists.push({file})
    },
    uploadFailed (err, file, fileList) {
      let i = this.fileLists.findIndex(f => f.url === file.uid)
      i !== -1 && this.fileLists.splice(i, 1)
      this.uploading = false
      this.$refs.uploadForm.validate()
      this.$message.error(`${file.name} 上传失败，请重新上传`)
      throw new Error(err)
    },
    updateFile (res, file, fileList) {
      let findFile = this.fileLists.find(f => f.loading && (f.url === file.uid || f.dragFile))
      this.uploading = false
      this.$refs.uploadForm.validate()
      let name = res[0].result.file
      let url = res[0].result.dir
      if (findFile) {
        let time = this.timers.find(t => t.id === findFile.url)
        time && clearInterval(time)
        findFile.progress = 100
        findFile.url = res[0].result.dir
        findFile.loading = false
      }
      //  清空文件
      this.$refs.uploadControl.clearFiles()
      // 更新归档这个一定要放在方法的最后, 否则会被下面value的监听影响
      if (this.component.properties.multiple === false) {
        this.update(`${''}$.$${name},${url}`)
      } else {
        let fileLists = `${this.value || ''}$.$${name},${url}`.split('$.$').slice(1)
        fileLists.sort((a, b) => {
          return (a.charCodeAt(0) - b.charCodeAt(0))
        })
        let value = '$.$' + fileLists.join('$.$')
        this.update(value)
      }
      // 触发值改变事件
      this.$nextTick(() => this.executeFunctions('change'))
    },
    // 拖拽更改文件归档顺序, 更改了顺序的时候更新归档的顺序
    updateFileOrder () {
      let value = ''
      this.fileLists.forEach(f => {
        value += `$.$${f.name},${f.url}`
      })
      this.update(value)
    },
    getDownLoadUrl (path) {
      //  return path.includes('USER') ? sessionStorage.getItem('downloadUrl') : sessionStorage.getItem('cdnDownloadUrl')
      return sessionStorage.getItem('ossDownloadUrl')
    },
    // 获取二进制文件
    getFile (file) {
      let url = ''
      if (file.url.includes('http')) {
        url = file.url
      } else {
        url = `${location.origin}/shared-api/files/download?data=${encodeURIComponent('$.$')}${encodeURIComponent(file.name)},${file.url}`
      }
      return this.$axios.get(url, {responseType: 'blob'})
    },
    downFile (file) {
      if (file.loading) {
        return this.$message.info('该文件正在上传中，请上传完成后再试')
      } else {
        this.getFile(file).then(res => {
          const url = window.URL.createObjectURL(res.data)
          const a = document.createElement('a')
          a.href = url
          a.download = file.name
          a.click()
          window.URL.revokeObjectURL(url)
        })
        // const x = new XMLHttpRequest()
        // x.open('GET', file.url, true)
        // x.responseType = 'blob'
        // x.onload = function (e) {
        //   const url = window.URL.createObjectURL(x.response)
        //   const a = document.createElement('a')
        //   a.href = url
        //   a.download = file.name
        //   a.click()
        //   window.URL.revokeObjectURL(url)
        // }
        // x.onerror = function () {
        //   window.open(file.url)
        // }
        // x.send()
      }
    },
    delFile (file, fileList) {
      // eslint-disable-next-line eqeqeq
      let findIndex = this.sortFileLists.findIndex(f => f.file.uid == file.url)
      findIndex !== -1 && this.sortFileLists[findIndex].cancel && this.sortFileLists[findIndex].cancel()
      this.sortFileLists.splice(findIndex, 1)
      // 删除前取消上传状态
      this.uploading = false
      this.$refs.uploadForm.validate()
      // eslint-disable-next-line eqeqeq
      let index = fileList.findIndex(item => item.url === file.url || (item.file && item.file.uid == file.url))
      if (this.value) {
        let list = this.value.split('$.$')
        list.splice(index + 1, 1)
        this.update(list.join('$.$'))
        // 触发值改变事件
        this.$nextTick(() => this.executeFunctions('change'))
      }
      index !== -1 && this.fileLists.splice(index, 1)
    },
    async previewFile (file) {
      if (file.loading) {
        return this.$message.info('该文件正在上传中，请上传完成后再试')
      } else {
        // 点击预览 关闭列表
        this.$refs && this.$refs.uploadDropdownMenu && this.$refs.uploadDropdownMenu.dropdown && this.$refs.uploadDropdownMenu.dropdown.hide()
        let src = file.url
        // 非 doc、docx、xls、xlsx 走 view 接口
        let types = src.split('.')
        let type = types[types.length - 1].toLowerCase()
        if (['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'].includes(type)) {
          let href = this.$router.resolve({name: 'filePreview', query: {src, name: file.name}}).href
          window.open(href, '_blank')
        } else if (['png', 'jpg', 'jpeg', 'gif', 'pdf', 'txt'].includes(type)) {
          try {
            await this.eventBus.$emit('form.previewPicture', ({component: this.component, src: file.url, fileLists: this.fileLists}))
          } catch (e) {
            console.log(e)
            return null
          }
          // pdf 与 txt 在ali oss文件系统上可以直接预览
          if (['pdf', 'txt'].includes(type)) {
            src.includes('http') ? window.open(src) : window.open(`${sessionStorage.getItem('ossDownloadUrl')}${src}`)
          } else {
            //  55th:所有租户用新预览
            this.redCatPreviewPic(src)
            // let href = this.$router.resolve({name: 'imagePreview', query: {src: sessionStorage.getItem('ossDownloadUrl') + src, name: file.name}}).href
            // window.open(href, '_blank')
          }
        } else {
          this.$message.info('暂不支持该类型文件预览')
        }
      }
    },
    // 新标签页打开
    async externalLinkPreview (file) {
      if (file.loading) {
        return this.$message.info('该文件正在上传中，请上传完成后再试')
      } else {
        // 点击预览 关闭列表
        this.$refs && this.$refs.uploadDropdownMenu && this.$refs.uploadDropdownMenu.dropdown && this.$refs.uploadDropdownMenu.dropdown.hide()
        let src = file.url
        // 非 doc、docx、xls、xlsx 走 view 接口
        let types = src.split('.')
        let type = types[types.length - 1].toLowerCase()
        if (['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'].includes(type)) {
          let href = this.$router.resolve({name: 'filePreview', query: {src, name: file.name}}).href
          window.open(href, '_blank')
        } else if (['png', 'jpg', 'jpeg', 'gif', 'pdf', 'txt'].includes(type)) {
          try {
            await this.eventBus.$emit('form.previewPicture', ({component: this.component, src: file.url, fileLists: this.fileLists}))
          } catch (e) {
            console.log(e)
            return null
          }
          // pdf 与 txt 在ali oss文件系统上可以直接预览
          if (['pdf', 'txt'].includes(type)) {
            src.includes('http') ? window.open(src) : window.open(`${sessionStorage.getItem('ossDownloadUrl')}${src}`)
          } else {
            let imageType = ['png', 'jpg', 'jpeg', 'gif']
            let fileList = this.fileLists.filter(f => !f.loading && imageType.includes(f.url.split('.').pop().toLowerCase()))
            // 过滤掉正在上传的其他文件，和非图片控件
            sessionStorage.setItem(this.symbolKey, JSON.stringify(fileList))
            let href = this.$router.resolve({name: 'imagePreview', query: {id: this.symbolKey, src}}).href
            window.open(href, '_blank')
          }
        } else {
          this.$message.info('暂不支持该类型文件预览')
        }
      }
    },
    // 打包下载
    packDown () {
      let fileName = this.component.properties.listType === 'picture' ? '下载的图片.zip' : '下载的文件.zip'
      let zip = new JSZip()
      let getFilePromiseArray = this.fileLists.map(file => {
        return this.getFile(file).then(res => {
          zip.file(file.name, res.data, {binary: true})
        })
      })
      return Promise.all(getFilePromiseArray).then(() => {
        zip.generateAsync({
          type: 'blob'
        }).then(content => {
          const url = window.URL.createObjectURL(content)
          const a = document.createElement('a')
          a.href = url
          a.download = fileName
          a.click()
          window.URL.revokeObjectURL(url)
        })
      })
      // let data = {data: this.value}
      // this.$axios({
      //   method: 'post',
      //   url: '/shared-api/files/downloadZip',
      //   responseType: 'blob',
      //   data
      // }).then(res => {
      //   let blob = new Blob([res.data], { type: 'application/zip' })
      //   let url = window.URL.createObjectURL(blob)
      //   let vDom = document.createElement('a')
      //   vDom.style.display = 'none'
      //   vDom.href = url
      //   vDom.setAttribute('download', fileName)
      //   document.body.appendChild(vDom)
      //   vDom.click()
      //   document.body.removeChild(vDom)
      //   window.URL.revokeObjectURL(url)
      // })
    },
    redCatPreviewPic (src) {
      let allowType = ['png', 'jpg', 'jpeg', 'gif']
      this.coverPicList = this.fileLists.filter((c, index) => {
        let type = c.name.split('.').pop()
        return !c.loading && allowType.some(n => n === type.toLocaleLowerCase())
      })
      this.previewFileSrc = src
      this.$nextTick(() => {
        this.swiperFlag = true
      })
    },
    fileProgress (file) {
      if (file) {
        // 拖动上传的没有该属性
        if (!file.uid) {
          // 拖拽上传的以size的值作为标志
          this.fileLists.push({name: file.name, url: file.size, loading: true, file, progress: 0, dragFile: true})
        }
        // 文件正在上传，假进度条 上传网速按平均400kb算
        let item = this.fileLists.find(f => f.url === file.uid || f.url === file.size)
        if (!this.timers.find(t => t.id === item.url)) {
          // 文件大小/b / 400kb * 1024的网速 / 100每秒要长的进度条 * 1000 转毫秒
          let step = file.size / (400 * 1024) / 100 * 1000
          let timer = setInterval(() => item.progress++ >= 98 && clearInterval(timer), step)
          item && this.timers.push({id: item.url, timer})
        }
      }
    },
    openDialog (params) {
      this.$nextTick(() => {
        this.dialogParams = {...params}
      })
    },
    async save () {
      this.dialogParams.visable = false
      // 需要删除没有勾选的文件
      await this.deleteFile('checked')
      this.$nextTick(() => this.$refs.uploadControl.submit())
    },
    cancel () {
      this.$refs.uploadControl.clearFiles()
      this.dialogParams.visable = false
      if (this.component.properties.multiple) {
        // 取消的时候，需要把ready状态的文件删除
        this.deleteFile('ready')
      }
    },
    deleteFile (status) {
      let index
      if (status === 'ready') {
        index = this.selectFileList.list.findIndex(f => f && f.status === 'ready')
      } else {
        index = this.selectFileList.selected.findIndex(f => !f.checked)
      }
      if (index !== -1) {
        this.selectFileList.list.splice(index, 1)
        this.selectFileList.selected.splice(index, 1)
        this.deleteFile(status)
      }
    },
    closePreview () {
      this.swiperFlag = false
    },
    removeSymbolKey () {
      this.symbolKey && sessionStorage.removeItem(this.symbolKey)
    }
  },
  beforeDestroy () {
    // 如果有文件正在上传、取消上传
    this.timers = null
    let findFiles = this.fileLists.filter(f => f.loading)
    findFiles.length > 0 && findFiles.forEach(f => this.$refs.uploadControl.abort(f.file))
    this.destroyDragEvent('uploadForm')
    this.removeSymbolKey()
    window.removeEventListener('beforeunload', this.removeSymbolKey)
    window.removeEventListener('load', this.removeSymbolKey)
  },
  computed: {
    getUploadSuccessFileLength () {
      return this.fileLists.filter(c => !c.loading).length
    },
    // 文件过小的时候，定时还没走完，文件已经上传完成，会导致进度冒了。。
    getPercentage () {
      return item => {
        if (item.progress >= 100) {
          item.progress = 100
          return 100
        } else {
          return item.progress
        }
      }
    },
    getFileList () {
      return this.selectFileList.selected.filter(f => f && f.status === 'ready') || []
    },
    getFileSize () {
      return size => {
        if (size < (1024 * 1024)) {
          return `${Math.floor((size / 1024) * 100) / 100}K`
        } else {
          return `${Math.floor((size / 1024 / 1024) * 100) / 100}M`
        }
      }
    },
    getSelectSize () {
      return this.getFileList.length ? this.getFileList.map(f => f.checked ? f.size : 0).reduce((x, y) => x + y) / 1024 / 1024 : 0
    },
    getNoUploadFile () {
      return this.getFileList.length ? this.getFileList.filter(f => f.size >= this.maxSize).length : 0
    },
    hasNewWindow () {
      return file => {
        let allowType = ['png', 'jpg', 'jpeg', 'gif']
        let type = file.name.split('.').pop()
        return allowType.some(n => n === type.toLocaleLowerCase())
      }
    }
  }
}
</script>

<style lang="scss">

  .el-form-item.hidden{
    .el-form-item__label{
      display: none;
    }
  }
  .rc-upload-not-img-style.el-form-item{
    .el-form-item__content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .accessory{
        padding-left: 15px;
      }
    }
  }
  .rc-upload-runtime.el-form-item {
    .el-form-item__content {
      .rc-upload-control {
        width: 61px;
        .el-upload {
          .upload-button {
            & > span {
              text-decoration: underline;
            }
          }
          .upload-button.rc-upload-button-drag{
            & > span {
              text-decoration: none;
            }
          }
        }
      }
      .img-accessory{
        display: inline-block;
        background: #F7F7F7;
        padding: 10px 0px 5px 10px;
        .imgs-drag-wraper{
          display: flex;
          flex-wrap: wrap;
        }
        .pack-down-all {
          color: #4592E4;
          i{
            filter: invert(50%) sepia(94%) saturate(1170%) hue-rotate(188deg) brightness(93%) contrast(92%);
          }
          i {
            display: inline-block;
            width: 12px;
            height: 12px;
           background: url("./assets/pack-download.png") no-repeat center;
          }
        }
        .img-pack-all{
          text-align: right;
          padding-right: 10px;
          color: #666666;
          line-height: 10px;
          i{
            filter: none;
            margin: 0px;
            cursor: pointer;
            color: #666666;
            background: url('./assets/pack-down-not-active.png') no-repeat center;
            &:hover{
              color: #3378c2;
              filter: invert(50%) sepia(94%) saturate(1170%) hue-rotate(188deg) brightness(93%) contrast(92%);
              background: url('./assets/pack-download.png') no-repeat center;
            }
          }
          .el-tooltip__popper.img-pre-tooltip {
            padding: 4px;
            font-size: 6px;
            margin-right: 0px !important;
          }
        }
      }
      .accessory {
        width: calc(100% - 61px);
        height: 100%;

        .item-one-file {
          width: 100%;
          position: relative;
          cursor: pointer;
          height: 30px;
          line-height: 30px;
          -moz-box-sizing: border-box; /*Firefox3.5+*/
          -webkit-box-sizing: border-box; /*Safari3.2+*/
          -o-box-sizing: border-box; /*Opera9.6*/
          -ms-box-sizing: border-box; /*IE8*/
          box-sizing: border-box;

          .file-name {
            display: inline-block;
            width: calc(100% - 40px);
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            line-height: 30px;
            height: 30px;
            color: #55ACF1;
            &:hover{
              color: #318ED9;
              text-decoration: underline;
            }
          }

          .el-icon-loading {
            position: absolute;
            top: 8.5px;
          }

          .el-icon-circle-close {
            &:before {
              position: relative;
              top: -14px;
            }
          }

          &:hover {
            color: #54ABF1;

            .preivew-or-down {
              display: block;
            }
          }

          .preivew-or-down {
            position: absolute;
            color: #fff;
            width: 80px;
            background: rgba(0, 0, 0, .72);
            border-radius: 4px;
            line-height: 60px;
            z-index: 9999;
            left: 70px;
            top: 25px;
            display: none;

            .icon {
              cursor: pointer;
            }
            i.el-icon-view {
               margin-right: 5px;
            }
            .preivew, .down {
              height: 30px;
              line-height: 30px;
              text-align: center;
              &:hover{
                color: #4592E4;
              }
            }
          }

          .picture-upload {
            width: 98px;
            padding-left: 4px;
            .down, .preivew, > div {
              height: 21px;
              line-height: 21px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              i {
                font-size: 12px;
                margin-right: 5px;
              }
              span {
                font-size: 12px;
                display: inline-block;
                width: calc(100% - 10px);
                text-align: left;
              }
            }
            .external-link-preview {
              &:hover{
                color: #4592E4;
                >i{
                  filter: invert(50%) sepia(94%) saturate(1170%) hue-rotate(188deg) brightness(93%) contrast(92%);
                }
              }
              > i {
                display: inline-block;
                width: 12px;
                height: 12px;
                background: url("./assets/link.png") no-repeat center;
              }
            }
          }

          @media (max-width: 1500px) {
            .preivew-or-down {
              left: 0;
            }
          }
        }
        .progress {
          height: 5px;
          position: absolute;
          top: 34px;
          width: 100%;
        }
      }
    }

    i.el-icon-upload {
      color: #3a8ee6;
    }

    .el-upload {
      text-align: left;
    }

    .el-form-item__content {
      .el-form-item__error {
        padding-top: 4px;
      }
    }
    .el-form-item__content:before{
      content: none;
    }
    .el-dropdown-link {
      cursor: pointer;
      .multiple-accessory{
        color: #54ABF1;
        &:hover{
          color: #318ED9;
          text-decoration: underline;
        }
      }
    }

    .el-icon-circle-close {
      color: red;
      opacity: 0;
      margin-left: 20px;
    }

    .item {
      &:hover {
        .el-icon-circle-close {
          opacity: 1;
        }
      }
    }
  }
  /* 拖入样式*/
  .rc-upload-runtime.rc-upload-drag-style{
    border: 1px dashed #55ACF1;
    background-color: #F4F5F5;
  }
  .rc-upload-dialog {
    .el-dialog {
      .el-dialog__body {
        padding: 15px 15px;
        & > .hint {
          padding: 15px 33px;
          line-height: 20px;
          .file-name {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: inline-block;
            max-width: 200px;
            vertical-align: bottom;
          }
        }
        .file-select-list {
          .title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid #EBEBEB;
            font-size: 13px;
            color: #323232;
            padding-bottom: 5px;
            .right {
              text-align: center;
              width: 80px;
            }
            .left {
              padding-left: 40px;
            }
          }
          .file-content {
            color: #323232;
            height: 202px;
            overflow: auto;
            .item {
              padding: 0 10px 0 5px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              height: 30px;
              line-height: 30px;
              .file-name {
                width: 300px;
                .name {
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  display: inline-block;
                  vertical-align: bottom;
                  width: 300px;
                  cursor: pointer;
                  .el-checkbox {
                    .el-checkbox__label {
                      color: #323232;
                    }
                    .el-checkbox__inner {
                      border-radius: 2px;
                      background-color: #fff;
                      border-color: #C2C3C4;
                      &:after {
                        border-color: #55ACF1;
                      }
                    }
                    .is-checked {
                      .el-checkbox__inner {
                        border-color: #55ACF1;
                      }
                    }
                  }
                }
                .name-hint {
                  width: 180px;
                }
              }
              .size {
                width: 75px;
                text-align: right;
              }
            }
            .checked-item {
              background-color: #f7fbfe;
            }
          }
          .file-footer {
            border-top: 1px solid #EBEBEB;
            padding-top: 10px;
          }
        }
      }
      .el-dialog__footer {
        padding-top: 0;
        .dialog-footer {
          .hint-button {
            .el-button {
              width: 104px;
              height: 30px;
              border: 1px solid rgba(84, 171, 241, 1);
              border-radius: 4px;
              padding: 0;
              color: #54ABF1;
            }
          }
          .select-file {
            .el-button {
              padding: 0;
              width: 104px;
              height: 30px;
            }
          }
        }
      }
    }
  }
  .el-dropdown-menu.rc-file-dropdown-picture {
    > div {
      > span {
        .el-dropdown-menu__item {
          .picture-upload {
            width: 98px;
            padding-left: 4px;
            .down, .preivew, > div {
              height: 21px;
              line-height: 21px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              i {
                font-size: 12px;
                margin-right: 5px;
              }
              span {
                font-size: 12px;
                display: inline-block;
                width: calc(100% - 10px);
                text-align: left;
              }
            }
            .pack-down-all {
              &:hover{
                color: #4592E4;
                >i{
                  filter: invert(50%) sepia(94%) saturate(1170%) hue-rotate(188deg) brightness(93%) contrast(92%);
                }
              }
              > i {
                display: inline-block;
                width: 12px;
                height: 12px;
                background: url("./assets/pack-download.png") no-repeat center;
              }
            }
            .external-link-preview {
              &:hover{
                color: #4592E4;
                >i{
                  // 白色图片采用滤镜转蓝色
                  filter: invert(50%) sepia(94%) saturate(1170%) hue-rotate(188deg) brightness(93%) contrast(92%);
                }
              }
              > i {
                display: inline-block;
                width: 12px;
                height: 12px;
                background: url("./assets/link.png") no-repeat center;
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/runtime/components/rc-upload.vue